import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { UserTypeService } from 'src/app/services/user-type.service';

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.css']
})
export class UserTypeComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  userTypeData: any = []
  singleUserType: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  id: any = ""
  recordName: any = ""
  recordId: any = ""
  searchKey: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService, private userTypeService: UserTypeService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllUserType()
    this.form = this.fb.group({
      description: [''],
      userTypes: this.fb.array([]),
    })
    this.editForm = this.fb.group({
      id: [''],
      description: [''],
      userTypes: this.fb.array([]),
    })
    this.addUserTypeObject()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllUserType();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllUserType();
  }

  get userTypesArr() {
    return this.form.get('userTypes') as FormArray;
  }

  userTypeObject() {
    return this.fb.group({
      "type": [''],
    })
  }

  addUserTypeObject() {
    this.userTypesArr.push(this.userTypeObject())
  }

  removeUserTypeObject(index: number) {
    this.userTypesArr.removeAt(index)
  }

  get userTypesArrEdit() {
    return this.editForm.get('userTypes') as FormArray;
  }

  addEditUserTypeObject() {
    this.userTypesArrEdit.push(this.userTypeObject())
  }

  removeEditUserTypeObject(index: number) {
    this.userTypesArrEdit.removeAt(index)
  }

  addUserType() {

    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return
    }


    let body = {
      "version": 0,
      "isActive": true,
      "description": '',
      "userTypes": this.form.get('userTypes').value.map((item: any) => item.type?.trim() || ''),
      "cid": this.cid
    }

    console.log(body)
    this.userTypeService.addUserType(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllUserType()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message || "Added successfully")
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error?.errors?.[0]?.description || "Error adding User Type");

      }
    )
  }

  updateUserType() {
    if (!this.editForm.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    const id = this.editForm.get('id').value?.trim();
    const description = this.editForm.get('description').value?.trim();

    let body = {
      "version": 0,
      "isActive": true,
      "description": description || '',
      "id": id,
      "userTypes": this.editForm.get('userTypes').value.map((item: any) => item.type?.trim() || ''),
      "cid": this.cid
    }

    console.log(body)
    this.userTypeService.updateUserType(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllUserType()
        this.cancelModel()
        this.editForm.reset()
        this.toastr.success(response.message || "Updated successfully")
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error?.errors?.[0]?.description || "Error updating User Type");
      }
    )
  }

  formReset() {
    this.form.reset()
    this.editForm.reset()
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButtonEdit")?.click()
  }

  getAllUserType() {
    this.isLoading = true

    this.userTypeService.getAllUserTypes(this.cid).subscribe(
      (res: any) => {
        console.log(res)
        this.userTypeData = res.response || []
        this.count = this.userTypeData.length
        this.isLoading = false

      },
      (err: any) => {
        console.log(err)
        this.isLoading = false
      }
    )
  }

  getUserTypeById(id: any) {
    this.userTypeService.getUserTypeById(id, this.cid).subscribe(
      (res: any) => {
        console.log(res)
        this.singleUserType = []
        this.singleUserType.push(res.response)
        this.editForm.patchValue({
          id: res.response.id,
          description: res.response.description,
        })
        this.userTypesArrEdit.clear();
        if (res.response.userTypes && res.response.userTypes.length > 0) {
          for (var i = 0; i < res.response.userTypes.length; i++) {
            this.userTypesArrEdit.push(this.fb.group({
              "type": res.response.userTypes[i]
            }))
          }
        }
        console.log(this.editForm.value)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  deleteUserTypeAction() {
    let record = this.userTypeData.find((r: any) => r.id === this.id);
    if (!record) return;

    let body = {
      "version": record.version || 0,
      "isActive": false,
      "description": record.description,
      "id": record.id,
      "userTypes": record.userTypes || [],
      "cid": this.cid
    };

    this.userTypeService.updateUserType(body).subscribe(
      (response: any) => {
        console.log(response);
        document.getElementById("deleteModalButton")?.click()
        this.toastr.success(response.message || "Deleted successfully")
        this.getAllUserType()
        this.recordName = ""
        this.recordId = ""
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error?.errors?.[0]?.description || "Error deleting User Type")
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.id = id;
    this.recordId = record.id;
    this.recordName = record.id;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }


  getAllUserTypeByWildSearchWithoutPagination() {
    // Basic local filter or reload
    this.getAllUserType()
  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.searchKey = ""
    this.getAllUserType()
  }
}
